export default __webpack_public_path__ + "static/media/connecting_web-xs@1x.aec16e3d.jpg";